import { Text, TextDescription, TextTitle } from "../components/Texts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Column from "../components/Column";
import DateFormatter from "../modules/utils/DateFormatter";
import DatePicker from "../components/DatePicker";
import Dropdown from "../components/Dropdown";
import Icon from "../components/Icon";
import React from "react";
import Row from "../components/Row";
import Section from "../components/Section";
import Separator from "../components/Separator";
import Table from "../components/Table";
import Trending from "components/performance/Trending";
import TrendingGraph1 from "components/performance/TrendingGraph1FB";
import TrendingGraph2 from "components/performance/TrendingGraph2FB";
import _find from "lodash/find";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import _values from "lodash/values";
import colors from "../styles/colors";
import { compose } from "redux";
import formatMetricValue from "../modules/utils/formatMetricValue";
import formatNumber from "../modules/utils/formatNumber";
import moment from "moment";

import performanceAction from "../modules/performance/actions";
import performanceSelectors from "../modules/performance/selectors";

import facebookActions from "../modules/facebook/actions";
import facebookSeletors from "../modules/facebook/selectors";

import mainActions from "../modules/main/actions";
import mainSelectors from "../modules/main/selectors";

import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";
import withUserPerm from "services/withUserPerm";

import Loading from "components/Loading";
import get from "lodash/get";
import { set } from "lodash";
import TopBar from "../components/TopBar";
import pageTitleList from "../modules/utils/pageTitleList";

const RmpFacebookConversions = () => {
  //eslint-disable-next-line no-unused-vars
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [t] = useTranslation();
  const dispatch = useDispatch();
  let history = useHistory();

  const [loadedSelfServiceSettings, setLoadedSelfServiceSettings] = useState(false);

  const currentAd = useSelector((state) => mainSelectors.currentFacebookAd(state));
  const fbGraphList = useSelector((state) => performanceSelectors.fbgraphList(state));
  const [selectedViewValue, setSelectedViewValue] = useState();
  const [yesterdayAsDefault, setYesterdayAsDefault] = useState(true);
  const [loading, setLoading] = useState(true);
  const [performanceDataState, setPerformanceDataState] = useState([]);
  const getFacebookSettingsResult = useSelector((state) => facebookSeletors.getFacebookSettingsResult(state));
  const location = useLocation();
  const RcrmAppAvailableResult = useSelector((state) => mainSelectors.checkAppAvailableResult(state));
  const [conversionDataList, setConversionDataList] = useState({
    rwidget: {},
    rcrm: {},
    googlesheets: {},
  });
  const { REACT_APP_RCRM_APP_ID } = process.env;
  const titleAndSubTitle = pageTitleList.getPageTitleList(t);
  const titleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].title
    : title;
  const subTitleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].subTitle || ""
    : "";

  useEffect(() => {
    if (!currentAd.ads_account_id) {
      getFacebookSettings();
    }
  }, []);

  useEffect(() => {
    if (loadedSelfServiceSettings === true) {
      checkAdsAccountConnection();
    }
  }, [currentAd, loadedSelfServiceSettings]);

  const getFacebookSettings = async () => {
    const facebookSettings = await dispatch(
      facebookActions.getFacebookSettings({
        token: rmpToken,
      }),
    );

    if (facebookSettings.result === 0 && facebookSettings.data[0] && facebookSettings.data[0].fb_ads_account_id) {
      dispatch(
        mainActions.SetFacebookAd({
          account_name: facebookSettings.data[0].fb_ads_account_name,
          ads_account_id: facebookSettings.data[0].fb_ads_account_id,
          type: "fb",
          currency_code: "THB",
          create_time: null,
          update_time: null,
        }),
      );

      setLoadedSelfServiceSettings(true);
    } else if (facebookSettings.result === 0 && facebookSettings.data.length === 0) {
      history.push("/no-connected-ads");
    }
  };

  const checkAdsAccountConnection = () => {
    if (!currentAd || currentAd === "" || !currentAd.ads_account_id) {
      history.push("/no-connected-ads");
    }
  };

  const getPerformance = async () => {
    try {
      setLoading(true);
      await dispatch(
        performanceAction.GetFBGraph({
          pixel_code_id: getFacebookSettingsResult.data[0].fb_ads_pixel_code_id,
          date_preset: selectedViewValue.key,
        }),
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedViewValue && currentAd.ads_account_id) {
      getPerformance();
    }
  }, [selectedViewValue, currentAd.ads_account_id, dispatch]);

  useEffect(() => {
    if (fbGraphList.rwidget && fbGraphList.rcrm && fbGraphList.googlesheets) {
      setConversionDataList({
        rwidget: fbGraphList.rwidget,
        rcrm: fbGraphList.rcrm,
        googlesheets: fbGraphList.googlesheets,
      });
    }
  }, [selectedViewValue, fbGraphList]);

  if (!yesterdayAsDefault && selectedViewValue && selectedViewValue.key === "today" && performanceDataState) {
    setYesterdayAsDefault(true);
    setLoading(false);
  }

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={titleName} subTitle={subTitleName} />
        </StyledContainerTopBar>
        <DatePicker
          key={moment.locale() + " " + yesterdayAsDefault}
          onSelected={setSelectedViewValue}
          defaultIndex={yesterdayAsDefault ? 1 : 0}
        />
      </StyledContainerTop>
      {loading === true ? (
        <Loading />
      ) : (location.pathname == "/rmp-conversions/fb/google-sheets" &&
          conversionDataList.googlesheets.all.totalConversions != "0.00") ||
        (location.pathname == "/rmp-conversions/fb/r-widget" &&
          conversionDataList.rwidget.all.totalConversions != "0.00") ||
        (location.pathname == "/rmp-conversions/fb/r-crm" && conversionDataList.rcrm.all.totalConversions != "0.00") ? (
        <>
          <Row margin="0 0 24px" columnSpacing="0" responsive>
            <Column>
              <RenderContent dataList={conversionDataList} selectedViewValue={selectedViewValue} />
            </Column>
          </Row>
        </>
      ) : (
        <EmptyContent />
      )}
    </div>
  );
};

export default compose(withUserPerm())(RmpFacebookConversions);

const EmptyContent = () => {
  const [t] = useTranslation();
  return (
    <StyledEmptyContainer>
      <p>{t("__no_data")}</p>
    </StyledEmptyContainer>
  );
};

const RenderContent = ({ dataList, selectedViewValue }) => {
  const location = useLocation();
  switch (location.pathname) {
    case "/rmp-conversions/fb/google-sheets":
      return <GoogleSheetsContent dataList={dataList.googlesheets} selectedViewValue={selectedViewValue} />;
    case "/rmp-conversions/fb/r-widget":
      return <RWidgetContent dataList={dataList.rwidget} selectedViewValue={selectedViewValue} />;
    case "/rmp-conversions/fb/r-crm":
      return <RCRMContent dataList={dataList.rcrm} selectedViewValue={selectedViewValue} />;
    default:
      return <div></div>;
  }
};

const RWidgetContent = ({ dataList, selectedViewValue }) => {
  const selectedViewRWidget = { title: "R-Widget", value: "R-Widget" };
  return <TrendingGraph1 dataList={dataList} view={selectedViewRWidget} selectedViewValue={selectedViewValue} />;
};

const GoogleSheetsContent = ({ dataList, selectedViewValue }) => {
  const selectedViewRAds = { title: "Google Sheets", value: "Google Sheets" };
  return <TrendingGraph1 dataList={dataList} view={selectedViewRAds} selectedViewValue={selectedViewValue} />;
};

const RCRMContent = ({ dataList, selectedViewValue }) => {
  const selectedView = { title: "R-CRM", value: "R-CRM" };
  return <TrendingGraph2 dataList={dataList} view={selectedView} selectedViewValue={selectedViewValue} />;
};

const StyledEmptyContainer = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
